module.exports = __webpack_public_path__ + "static/img/01-submission-type.d53e3e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lti-assignment-guide/01-submission-type.png
// module id = GzVj
// module chunks = 1